<div class="heading-tab">
    <h3 class="heading" style="margin-top: -7em; margin-left: -17.5em;"><i nz-icon type="file-text"></i> Reports</h3>
</div>

<div *ngIf="refreshReportsComponent">
    <div style="margin-top: 20px;display: flex;" >
        <div class="p-b-20" style="margin-right: 20px;" >
            <h3>Report category</h3>
            <nz-select style="width: 250px;" nzShowSearch nzAllowClear nzPlaceHolder="Report category" [(ngModel)]="reportName"
                (ngModelChange)="getSubReport(reportName)" >
               <nz-option
                          *ngFor="let names of (lookup$['nbuReportNames'] | async) as LookupList; trackBy:names?.lookupKey"
                          [nzLabel]="names?.lookupValue" [nzValue]="names?.lookupKey"></nz-option>
            </nz-select>
        </div>

        <div class="p-b-20" *ngIf="!hideSubReportField">
            <h3>Report name</h3>
            <nz-select style="width: 200px;" nzPlaceHolder="Report Type" [(ngModel)]="subReportName"
                (ngModelChange)="getMetaData(reportName ,subReportName)">
                <nz-option
                *ngFor="let names of (lookup$['nbuReportNames'] | async) as LookupList; trackBy:names?.lookupKey"
                [nzLabel]="names?.lookupValue" [nzValue]="names?.lookupKey"></nz-option>
            </nz-select>
        </div>
    </div>

    <!-- date criteria -->
    <!-- <div *ngIf ="reportName != 'HOURLY_PRODUCTIVITY' && reportName != 'DAILY_MIS_PRODUCTIVITY_NBU'" style="margin-top: 20px;display: flex;"> -->
    <div *ngIf ="reportName != 'HOURLY_PRODUCTIVITY'" style="margin-top: 20px;display: flex;">

        <div class="flexie-auto-grid">
            <div class="p-b-20">
                <h3>Frequency</h3>
                <nz-select style="width: 200px;" nzPlaceHolder="Frequency" [(ngModel)]="selectedDateFrequency"
                    (ngModelChange)="getDateModels(selectedDateFrequency)">
                    <nz-option *ngFor="let frequency of dateFrequency" [nzLabel]="frequency"
                        [nzValue]="frequency">
                        {{frequency|| '' | translate}}
                    </nz-option>
                </nz-select>
            </div>

            <div class="p-b-20" *ngIf="selectedDateFrequency == 'Daily'">
                <h3>Date</h3>
                <nz-date-picker id="fromDate" style="width:100%" [(ngModel)]="startValue" [nzDisabledDate]="disabledStartDate" 
                (ngModelChange)="onStartChange($event);setDailyDate()">
                </nz-date-picker>
            </div>

            <div class="p-b-20" *ngIf="selectedDateFrequency == 'Monthly'">
                <h3>Select Month</h3>
                <nz-month-picker id="toDate" style="width:100%" [(ngModel)]="selectedMonthValue" nzPlaceHolder="Select month" (ngModelChange)="setMonthlyDate($event)">
                </nz-month-picker>
            </div>

            <div class="p-b-20" *ngIf="selectedDateFrequency == 'Quarterly'">
                <h3>Select Quarter</h3>
                <nz-select style="width: 200px;" nzPlaceHolder="Quarters" [(ngModel)]="selectedQuarter"
                    (ngModelChange)="setQuarterlyDate()">
                    <nz-option *ngFor="let quarters of fiscalQuarter; trackBy:quarters?.lookupKey" [nzLabel]="quarters?.lookupValue"
                        [nzValue]="quarters?.lookupKey">
                        {{quarters?.lookupValue|| '' | translate}}
                    </nz-option>
                </nz-select>
            </div>
            <div class="p-b-20" *ngIf="selectedDateFrequency == 'Quarterly'">
                <h3>Select year</h3>
                <nz-date-picker nzMode="year" [(ngModel)]="selectedQtryearValue" (ngModelChange)="setQuarterlyDate($event)"></nz-date-picker>
            </div>

            <div class="p-b-20" *ngIf="selectedDateFrequency == 'Yearly'">
                <h3>Select year</h3>
                <nz-date-picker nzMode="year" [(ngModel)]="selectedyearValue" (ngModelChange)="setYearlyDate($event)"></nz-date-picker>
            </div>

            <div class="p-b-20" *ngIf="selectedDateFrequency == 'Financial Year'">
                <h3>From year</h3>
                <nz-date-picker nzMode="year" [(ngModel)]="selectFinancialStartYear" (ngModelChange)="setFinancialYearStartDate($event)"></nz-date-picker>
            </div>
            <div class="p-b-20" *ngIf="selectedDateFrequency == 'Financial Year'">
                <h3>To year</h3>
                <nz-date-picker nzMode="year" [(ngModel)]="selectFinancialEndYear" (ngModelChange)="setFinancialYearEndDate($event)"></nz-date-picker>
            </div>
        </div>
    </div>
    
    <!-- optional criteria -->
    <!-- <div style="margin-top: 20px;display: flex;"> -->
        <div style="margin-top: 20px;display: flex;">
            <div *ngFor="let field of inputFieldsMap">
                <div class="p-b-20" style="margin-right: 10px;" *ngIf="field.attributeLookupCd == null">
                    <h4>{{field?.description|| '' | translate}} &emsp</h4>
                    <input nz-input type="field.attributeDataTypeCd" style="width:100%" name="inputValue" id="proposalNum"
                        [(ngModel)]="field.inputValue" (ngModelChange)="InputFieldValidation()" required>
                </div>
                <div class="p-b-20" style="margin-right: 20px;" *ngIf="field.attributeLookupCd != null">
                    <h4>{{field?.description|| '' | translate}}</h4>
                    <nz-select id="gender" style="width:200%" nzShowSearch nzPlaceHolder="field?.description" [(ngModel)]="field.inputValue" (ngModelChange)="InputFieldValidation()">
                        <nz-option *ngFor="let item of (lookup$[field.attributeLookupCd] | async) as genderCdCdLookup; trackBy:item?.lookupKey"
                            [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
                    </nz-select>
                </div>
            </div>

            <div></div>
            <div></div>
        </div>
    <!-- </div> -->

    <div style="margin-top: 20px">
       
    </div>

    <div class="flexie-auto-grid" style="margin-top: 30px">
        <div>
            <!-- <nz-select nzMode="multiple" nzPlaceHolder="Filter" style="width: 100%" [(ngModel)]="listOfSelectedValue"
                (ngModelChange)="filterTable(listOfSelectedValue)">
                <nz-option *ngFor="let option of listOfOption" [nzLabel]="option.label" [nzValue]="option.value">
                </nz-option>
            </nz-select> -->
            <!-- <ng-template #tagPlaceHolder let-selectedList> + {{ selectedList.length }} more </ng-template> -->
        </div>
        <div></div>
        <div></div>
        <div style="text-align: right">
            <button nz-button class="m-r-10" nzType ="'generate'"  (click)="getReport()"
                >Generate</button>
            <button nz-button class="m-r-10" nzType ="'generate'" (click)="generateExcel()"
            >Export</button>
        </div>
    </div>

    <!-- <div class="flexie-auto-grid" style="margin-top: 30px">
        <div style="display: contents;" *ngFor="let column of reportOutputFields; trackBy:column?.description">
            <label nz-checkbox
                (nzCheckedChange)="selectedOutputFields($event, column)"><b>{{column.description}}</b></label>
        </div>
        <div></div>
        <nz-table #reportsTable [nzData]="reportList" [nzShowPagination]="false">
                <thead>
                    <tr>
                        <th *ngFor="let column of reportOutputFields; trackBy:column?.description">{{column.description}}</th>
                    </tr>
                </thead>
            </nz-table>
        <div></div>
        <div></div>
    </div> -->
</div>
<div class="search-results m-t-20" style="overflow-x: auto; overflow-y: auto;">
    

    <nz-table #reportsTable *ngIf="showReportTable" [nzData]="reportData" [(nzPageIndex)]="mapperTableIndex" [nzShowPagination]="reportData.length > 10 ? true : false"  [nzScroll]="{ x: '1150px' }">
        <thead>
            <tr>
                <th style="width:100px;">Sr. No.</th>
                <th style="word-break: initial;" *ngFor="let column of tabelHeaders; trackBy:column?.description">{{column.description}}</th>
            </tr>
        </thead>
        <tbody>
                <ng-container *ngFor="let report of reportsTable.data; let i = index">
                    <tr>
                        <td style="width:50px;">{{i + 1  + ((mapperTableIndex-1) * mapperTablePageSize) }}</td>
                        <td style="word-break: initial;" *ngFor="let column of tabelHeaders">
                            <ng-container *ngIf="column.attributeName !== 'CURRENCY' && column.attributeName !== 'FINALPREMIUM' && column.attributeName !== 'PROPOSALNUM' ">
                                {{ column.attributeDataTypeCd.includes('LocalDateTime') || column.attributeDataTypeCd.includes('LocalDate') ? (report[column.attributeName] | date:'dd/MM/yyyy') 
                                : column.attributeDataTypeCd.includes('LocalTime') ? (report[column.attributeName] | date:'hh:mm:ss a') 
                                : column.attributeDataTypeCd.includes('Boolean') ? (report[column.attributeName] ? 'yes' : 'no') 
                                : (report[column.attributeName] | technicalTranslate) || '-' }}
                            </ng-container>


                            <ng-container *ngIf="column.attributeName == 'CURRENCY'">
                                {{ column.attributeDataTypeCd.includes('LocalDateTime') || column.attributeDataTypeCd.includes('LocalDate') ? (report[column.attributeName] | date:'dd/MM/yyyy') 
                                : column.attributeDataTypeCd.includes('LocalTime') ? (report[column.attributeName] | date:'hh:mm:ss a') 
                                : (report[column.attributeName] || '-') }}
                            </ng-container>

                            <ng-container *ngIf="column.attributeName == 'FINALPREMIUM'">
                                {{ report[column.attributeName] |  CurrencyFormatter : (report.currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue) || '-'}}

                            </ng-container>

                            <ng-container *ngIf="column.attributeName == 'PROPOSALNUM'">
                                {{ report[column.attributeName] || '-'}}

                            </ng-container>
                        </td>
                    </tr>
                </ng-container>
        </tbody>
    </nz-table>

    <!-- <nz-table #reportsTable [nzData]="reportList" [nzShowPagination]="false" *ngIf="reportName == 'PolicyRptByAgent'">
            <thead>
                <tr>
                    <th>Intimation Number</th>
                    <th>Intimation Date</th>
                    <th>Intimation Time</th>
                    <th>Base Product</th>
                    <th>Event Type</th>
                    <th>Policy Number</th>
                    <th>Event Date</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let report of reportData; let i = index">
                    <td>{{report.CLMINTIMATIONNUM}}</td>
                    <td>{{report.INTIMATIONDT | date:'dd/MM/yyyy'}}</td>
                    <td>{{report.INTIMATIONTM | date:'HH:mm'}}</td>
                    <td>{{report.BASEPRODUCTCD}}</td>
                    <td>{{report.EVENTTYPECD}}</td>
                    <td>{{report.POLICYNUM}}</td>
                    <td>{{report.EVENTDT | date:'dd/MM/yyyy'}}</td>                
                </tr>
            </tbody>
        </nz-table> -->
</div>